'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                d: 'M5.902 56.881h14.754l25.314-6.406 12.811-8.327a2.74 2.74 0 0 0 .42-4.212 2.717 2.717 0 0 0-3.436-.342l-9.535 6.452H28.525h5.901',
                stroke: '#3F5060',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                d: 'M38.934 44.046l9.945-6.452a2.717 2.717 0 0 1 3.437.342c.417.417.667.93.758 1.463',
                stroke: '#3F5060',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                d: 'M37.377 30.224a3.942 3.942 0 0 1-3.934 3.949 3.942 3.942 0 0 1-3.935-3.95 3.942 3.942 0 0 1 3.935-3.949 3.942 3.942 0 0 1 3.934 3.95z',
                fill: '#FFC400'
            }),
            _react2.default.createElement('path', {
                d: 'M37.377 30.224a3.942 3.942 0 0 1-3.934 3.949 3.942 3.942 0 0 1-3.935-3.95 3.942 3.942 0 0 1 3.935-3.949 3.942 3.942 0 0 1 3.934 3.95z',
                stroke: '#3F5060',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                d: 'M49.18 16.401a3.942 3.942 0 0 1-3.934 3.95 3.942 3.942 0 0 1-3.935-3.95 3.942 3.942 0 0 1 3.935-3.949 3.942 3.942 0 0 1 3.934 3.95z',
                fill: '#FFC400'
            }),
            _react2.default.createElement('path', {
                d: 'M49.18 16.401a3.942 3.942 0 0 1-3.934 3.95 3.942 3.942 0 0 1-3.935-3.95 3.942 3.942 0 0 1 3.935-3.949 3.942 3.942 0 0 1 3.934 3.95z',
                stroke: '#3F5060',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                d: 'M47.213 25.287v1.975M43.279 29.236h1.967M49.18 29.236h1.968M47.213 31.211v1.975M19.672 20.35v1.975M15.738 24.3h1.967M21.64 24.3h1.967M19.672 26.274v1.975',
                stroke: '#A7F2EB',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                stroke: '#3F5060',
                strokeWidth: '1.972',
                d: 'M0 46.02h5.902v14.81H0M6.469 46.02h3.367l9.189-6.559a5.89 5.89 0 0 1 3.738-1.339h16.581v1.975a3.942 3.942 0 0 1-3.934 3.95h-6.885'
            }),
            _react2.default.createElement('path', {
                d: 'M.984 55.894v1.974',
                stroke: '#B2B9BF',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                d: 'M27.541 12.452c0 1.09-.881 1.975-1.967 1.975a1.972 1.972 0 0 1-1.967-1.975c0-1.09.88-1.974 1.967-1.974 1.086 0 1.967.884 1.967 1.974z',
                fill: '#FFC400'
            }),
            _react2.default.createElement('path', {
                d: 'M27.541 12.452c0 1.09-.881 1.975-1.967 1.975a1.972 1.972 0 0 1-1.967-1.975c0-1.09.88-1.974 1.967-1.974 1.086 0 1.967.884 1.967 1.974z',
                stroke: '#3F5060',
                strokeWidth: '1.972'
            }),
            _react2.default.createElement('path', {
                d: 'M25.574 6.528V2.95M25.574.975V-1M33.443 22.942v-3.579M33.443 17.389v-1.975M45.246 10.107V6.528M45.246 4.554V2.579',
                stroke: '#FFEDBB',
                strokeWidth: '1.972'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '60',
    viewBox: '0 0 60 60',
    xmlns: 'http://www.w3.org/2000/svg'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;